export const WHATSAPP_PRODUCTS = [
  'RECRUITMENT',
  'ENGAGEMENT',
  'LEARNING',
  'PAYROLL',
  'PERFORMANCE',
  'PERSONAS_HRIS',
] as const;

export type TWhatsappProductId = (typeof WHATSAPP_PRODUCTS)[number];

export const CREHANA_EMAIL_DOMAIN = '@crehana.com';

export const WHATSAPP_MANAGER_URL =
  'https://business.facebook.com/wa/manage/message-templates/';

export const WHATSAPP_TEMPLATES_PAGE_SIZES = [10, 15, 20, 25] as const;

export const WHATSAPP_MOCK_DELAY_MS = 600;
